import { createContext } from 'react';
import initialCompanyState from './initialCompanyState';

const CompanyContext = createContext(initialCompanyState);

export default CompanyContext;
